

import React, { useState } from "react";
import { useSelector } from "react-redux";
import {  useNavigate } from "react-router-dom";

export default function Cart({ onClose }) {
  const { items, totalQuantity } = useSelector((state) => state.cart);
  const [hoveredImage, setHoveredImage] = useState(null);
  const navigate = useNavigate();

  const openModal = (image) => setHoveredImage(image);
  const closeModal = () => setHoveredImage(null);

  return (
    <div className="absolute top-14 right-5 bg-white shadow-lg border border-gray-300 rounded-lg w-80 max-h-96 p-4 z-50 overflow-y-auto">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold">Tool Cart</h2>
        <button
          onClick={onClose}
          className="text-gray-500 hover:text-gray-700 text-xl"
        >
          ✖
        </button>
      </div>

      {/* Cart Items */}
      {items.length > 0 ? (
        <div>
          <ul className="divide-y divide-gray-200">
            {items.map((item, index) => (
              <li key={index} className="flex gap-4 py-3">
                {/* Product Image */}
                <div
                  className="w-36 h-16 overflow-hidden rounded-md cursor-pointer"
                  onClick={() => openModal(item.quotation_product_img)}
                >
                  <img
                    src={item.quotation_product_img || "https://via.placeholder.com/150"}
                    alt={item.product_code || "Product Image"}
                    className="w-full h-full object-cover rounded-md"
                  />
                </div>

                {/* Product Details */}
                <div className="flex-1 flex items-center">
                  <h3 className="text-sm font-medium">{item.product_code}</h3>
                </div>
              </li>
            ))}
          </ul>

          {/* Total Summary */}
          <div className="mt-4">
            <p className="text-sm font-semibold">
              Total Items: <span>{totalQuantity}</span>
            </p>
            <button className="mt-2 w-full main-color text-white py-2 rounded-md"
             onClick={()=>{
                onClose()
                navigate('/preview_multiple_quotation')
             }}
            >
              Create Quotation
            </button>
          </div>
        </div>
      ) : (
        <p className="text-sm text-gray-500">Your cart is empty.</p>
      )}

      {/* Modal for Hovered Image */}
      {hoveredImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          onMouseLeave={closeModal}
        >
          <div className="relative">
            <img
              src={hoveredImage}
              alt="Hovered Product"
              className="max-w-full max-h-full rounded-lg"
            />
            <button
              onClick={closeModal}
              className="absolute top-2 right-2 text-white text-lg bg-gray-800 bg-opacity-50 rounded-full p-2"
            >
              ✖
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
